import { appHttpClient } from "../../installations/http/axiosInterfaces";

const getBusinessCustomerList = () => {
  return appHttpClient.get("/BusinessCustomer/List");
};

const businessCustomerService = {
  getBusinessCustomerList,
};

export default businessCustomerService;
